// components/Header/Header.tsx
import React, { useState } from "react";
import "./Header.css";
import Logo from "../../assets/logo.svg";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import SavedMessages from "../SavedMessages/SavedMessages";
import DocumentExplorer from "../DocumentExplorer/DocumentExplorer";
import { useAppSelector, useAppDispatch } from "../../hooks/redux";
import { setCurrentSession } from "../../store/slices/chatSlice";

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isSavedMessagesOpen, setIsSavedMessagesOpen] = useState(false);
  const [isDocumentExplorerOpen, setIsDocumentExplorerOpen] = useState(false);
  const savedMessagesCount = useAppSelector((state) => state.chat.savedMessages.length);

  const openSavedMessages = () => {
    setIsSavedMessagesOpen(true);
  };

  const closeSavedMessages = () => {
    setIsSavedMessagesOpen(false);
  };

  const openDocumentExplorer = () => {
    setIsDocumentExplorerOpen(true);
  };

  const closeDocumentExplorer = () => {
    setIsDocumentExplorerOpen(false);
  };

  return (
    <>
      <header className="header">
        <div
          className="header-logo"
          onClick={() => dispatch(setCurrentSession(null))}
          title="Zur Startseite"
        >
          <img src={Logo} alt="Logo" />
        </div>
        <div className="header-controls">
          <button
            className="header-btn register documents-header-btn"
            onClick={openDocumentExplorer}
            aria-label="Dokumenten-Explorer öffnen"
            title="Dokumenten-Explorer"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9C21 7.89543 20.1046 7 19 7H13L11 5H5C3.89543 5 3 5.89543 3 7Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </button>
          <button
            className="header-btn register bookmark-header-btn"
            onClick={openSavedMessages}
            aria-label="Gespeicherte Nachrichten öffnen"
            title="Gespeicherte Nachrichten"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
                stroke="currentColor"
                strokeWidth="2"
                fill="currentColor"
              />
            </svg>
            <span className="bookmark-count">{savedMessagesCount || ""}</span>
          </button>
          <ThemeToggle />
        </div>
      </header>

      <DocumentExplorer
        isOpen={isDocumentExplorerOpen}
        onClose={closeDocumentExplorer}
      />

      <SavedMessages
        isOpen={isSavedMessagesOpen}
        onClose={closeSavedMessages}
      />
    </>
  );
};

export default Header;
